import { Button } from "@mui/material";
import { styleConst } from "../../utils/style";


export const ButtonL = ({
    isSelected,
    onClick,
    text,
    primaryColor,
    secondaryColor,
}) => {

  const primary = primaryColor || styleConst.primaryColor
  const secondary = secondaryColor || styleConst.pgbackground

  return (
    <Button
      sx={{
        display: "flex",
        color: isSelected ? primary : secondary,
        backgroundColor: isSelected ? secondary : primary,
        border: `2px solid ${isSelected ? primary : secondary}`,
        textDecoration: "none",
        textAlign: "center",
        padding: "0.75rem 0.5rem",
        width: "fit-content",
        minWidth: "10rem",
        fontFamily: "inherit",
      }}
      onClick={() => onClick(text)}
    >
        {text}
    </Button>
  );
}